import { useRef, useState } from "react";
import { Music, VolumeX } from "lucide-react";
import { toast } from "sonner";

const VIDEO_ID = "ebIOIzMYPAs"; // Prada Tune (Instrumental Loop)

let ytApiPromise = null;
function loadYT() {
  if (window.YT?.Player) return Promise.resolve(window.YT);
  if (!ytApiPromise) {
    ytApiPromise = new Promise((resolve) => {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(tag);
      window.onYouTubeIframeAPIReady = () => resolve(window.YT);
    });
  }
  return ytApiPromise;
}

export default function MusicToggle() {
  const playerRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [loading, setLoading] = useState(false);

  const toggle = async () => {
    if (playerRef.current) {
      if (playing) {
        playerRef.current.pauseVideo();
        setPlaying(false);
      } else {
        playerRef.current.playVideo();
        setPlaying(true);
      }
      return;
    }
    setLoading(true);
    const YT = await loadYT();
    playerRef.current = new YT.Player("hype-song-player", {
      videoId: VIDEO_ID,
      playerVars: { autoplay: 1, controls: 0, loop: 1, playlist: VIDEO_ID },
      events: {
        onReady: (e) => {
          e.target.setVolume(35);
          e.target.playVideo();
          setLoading(false);
          setPlaying(true);
          toast("🎵 Prada Tune (Instrumental) · Chase's hype song", { duration: 3000 });
        },
        onStateChange: (e) => {
          if (e.data === YT.PlayerState.PLAYING) setPlaying(true);
          if (e.data === YT.PlayerState.PAUSED) setPlaying(false);
        },
        onError: () => {
          setLoading(false);
          toast.error("Couldn't load the hype song right now");
        },
      },
    });
  };

  return (
    <>
      <div className="fixed w-px h-px opacity-0 pointer-events-none bottom-0 left-0 overflow-hidden">
        <div id="hype-song-player" />
      </div>
      <button
        onClick={toggle}
        data-testid="music-toggle-btn"
        aria-label={playing ? "Mute hype song" : "Play Chase's hype song"}
        className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 rounded-full pl-4 pr-5 py-3 font-sub text-sm font-semibold backdrop-blur-xl border transition-colors duration-300 active:scale-95 ${
          playing
            ? "bg-purple-600/90 border-purple-400 text-white drop-shadow-[0_0_20px_rgba(147,51,234,0.6)]"
            : "bg-zinc-900/90 border-white/15 text-zinc-300 hover:border-purple-400 hover:text-white"
        }`}
      >
        {playing ? (
          <span className="flex items-end gap-[3px] h-4" aria-hidden="true">
            <span className="eq-bar" style={{ animationDelay: "0ms" }} />
            <span className="eq-bar" style={{ animationDelay: "150ms" }} />
            <span className="eq-bar" style={{ animationDelay: "300ms" }} />
          </span>
        ) : (
          <Music className="w-4 h-4" />
        )}
        <span className="hidden sm:inline">
          {loading ? "Loading..." : playing ? "Prada Tune (Instrumental)" : "Play Hype Song"}
        </span>
        {playing && <VolumeX className="w-4 h-4 opacity-70" />}
      </button>
    </>
  );
}
